import type {CacheKeys} from '../typedef';

type GetSearchResultPath =
    <SearchFields, SortFields, Filters>(cachedKeys: CacheKeys<SearchFields, SortFields, Filters>) => string;

export const getSearchResultPath: GetSearchResultPath = cachedKeys => JSON.stringify(cachedKeys);
